import HeroProductSingle from "./HeroProductSingle";
export default HeroProductSingle;